<template>
  <div class='EnbContent'
  :style="{ color: Prefes.lojaCorFonte.color }"
  >
    <router-view :data="data"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'EnbContent',
  props: ['data'],
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.EnbContent {
  width: 100%;
}
</style>
